<template>
  <a-drawer
    title="Plantillas predefinidas"
    :width="450"
    v-model:visible="visible"
    :body-style="{ padding: '0' }"
    @close="handleClose"
  >
    <p class="drawer__description">
      Hemos creado plantillas predefinidas, podras agregar tipos de datos especificos para tus
      contactos y realizar actualizaciones de ellos.
    </p>

    <custom-scrollbar height="calc(100vh - 160px)">
      <h2 class="drawer__title">Selecciona una plantilla para:</h2>

      <div class="drawer__subtitle">Importa información complementaria para tus contactos:</div>
      <download-template-item v-for="item in templates.clients" :key="item.type" :item="item" />

      <div class="drawer__subtitle" style="margin-top: 12px">
        Realiza acciones a la información actual de tus contactos
      </div>
      <download-template-item v-for="item in templates.others" :key="item.type" :item="item" />
    </custom-scrollbar>
  </a-drawer>
</template>

<script>
import { defineComponent } from "vue";

import { templates } from "@/app/imports/utils/templates";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import DownloadTemplateItem from "./DownloadTemplateItem.vue";

export default defineComponent({
  components: {
    CustomScrollbar,
    DownloadTemplateItem,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      templates,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
  },
});
</script>

<style lang="sass" scoped>

.drawer
  &__description
    color: $gray-8
    margin-top: 12px
    padding: 0 24px

  &__title
    color: $gray-9
    font-size: 16px
    padding: 0 24px
    font-weight: 600

  &__subtitle
    color: $gray-9
    padding: 8px 20px
    font-weight: 600
    font-size: 14px

  &__item
    font-size: 14px
    line-height: 22px
    color: $gray-8
    border-top: $border-normal
    padding: 12px 24px
</style>
